import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/politique-de-confidentialite")({
  beforeLoad: () => {
    throw redirect({ to: "/mentions-legales" });
  },
});
